/* eslint-disable react/style-prop-object */
import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Popconfirm, Select, notification } from 'antd';
import UserPenIconComponent from '../../../../assets/icons/UserPenIcon';
import DeleteIconComponent from '../../../../assets/icons/DeleteIcon';
import NewsService from '../../../../services/news';

const { Option } = Select;

const ManageNewsCateForm = () => {
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();

    const handleAdd = () => {
        setIsModalOpen(true);
        setEditingItem(null);
        form.resetFields();
    };

    const handleEdit = (record: any) => {
        // console.log(record.id, 'id')
        setIsModalOpen(true);
        setEditingItem(record.id);
        form.setFieldsValue(record);
    };

    const handleDelete = async (key: number) => {
        const obj = {
            id: key
        }
        const result = await NewsService.deleteNewsCategoryCMS(obj);
        // console.log(result.response?.data, 'result form')
        if (result.response?.data.message === "success") {
            api.success({
                message: 'Xóa thành công danh mục tin tức!',
                showProgress: true,
                pauseOnHover: true,
            });
        }
        fetchNewsCategories();
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (editingItem) {
                // Updating existing category
                const obj = {
                    id: editingItem,
                    categoryName: values.categoryName,
                    status: values.status
                };
                const result = await NewsService.updateNewsCategoryCMS(obj);
                if (result.response?.data.message === "success") {
                    api.success({
                        message: 'Cập nhật thành công danh mục tin tức!',
                        showProgress: true,
                        pauseOnHover: true,
                    });
                } else {
                    api.error({
                        message: 'Có lỗi xảy ra khi cập nhật danh mục!',
                        description: result.response?.data.message || 'Unknown error',
                        showProgress: true,
                        pauseOnHover: true,
                    });
                }
            } else {
                // Creating new category
                if (values.categoryName && values.status) {
                    const result = await NewsService.createNewsCategoryCMS(values);
                    if (result.response?.data.message === "success") {
                        api.success({
                            message: 'Tạo thành công danh mục tin tức mới!',
                            showProgress: true,
                            pauseOnHover: true,
                        });
                    } else {
                        api.error({
                            message: 'Có lỗi xảy ra khi tạo danh mục!',
                            description: result.response?.data.message || 'Unknown error',
                            showProgress: true,
                            pauseOnHover: true,
                        });
                    }
                } else {
                    api.error({
                        message: 'Vui lòng điền đầy đủ thông tin!',
                        description: 'Tên và trạng thái không được để trống.',
                        showProgress: true,
                        pauseOnHover: true,
                    });
                }
            }
            fetchNewsCategories();
            setIsModalOpen(false);
        } catch (error) {

            api.error({
                message: 'Vui lòng điền đầy đủ thông tin!',
                showProgress: true,
                pauseOnHover: true,
            });
        }
    };



    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const fetchNewsCategories = async () => {

        try {
            const result = await NewsService.getListNewsCategoryCMS();
            // console.log(result.data, 'result')
            if (result.data.message === 'success') {
                setData(result.data.data);
            } else {
                notification.error({
                    message: 'Có lỗi xảy ra!',
                    description: result.data.message || 'Chi tiết lỗi không rõ.',
                    showProgress: true,
                    pauseOnHover: true,
                });
            }
        } catch (error) {
            notification.error({
                message: 'Lỗi hệ thống máy chủ!',
                showProgress: true,
                pauseOnHover: true,
            });
        }
    };

    useEffect(() => {
        fetchNewsCategories();
    }, []);

    const columns = [

        {
            title: 'Tên',
            dataIndex: 'categoryName',
            key: 'categoryName',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => {
                if (status === 'Active') {
                    return <div className='text-success'>Đã xác nhận</div>;
                } else if (status === 'Deactive') {
                    return <div className='text-colorThird'>Chưa xác nhận</div>;
                } else if (status === 'Deleted') {
                    return 'Đã xóa';
                } else {
                    return 'Trạng thái không xác định';
                }
            },
        },
        // {
        //     title: 'Mô tả',
        //     dataIndex: 'description',
        //     key: 'description',
        // },
        // {
        //     title: 'Đường dẫn',
        //     dataIndex: 'slug',
        //     key: 'slug',
        // },
        {
            title: '',
            key: 'actions',
            render: (_: any, record: any) => (
                <span>
                    <Button type="link"
                        onClick={() => handleEdit(record)}
                    >
                        <UserPenIconComponent style='w-5 h-5 fill-colorSecondary' />
                    </Button>
                    <Popconfirm
                        title="Bạn có muốn xóa mục này không?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button type="link" danger>
                            <DeleteIconComponent style='w-5 h-5 fill-colorThird' />
                        </Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];

    return (
        <div>
            {contextHolder}
            <Button type="primary" onClick={handleAdd} style={{ marginBottom: 16 }}>
                Thêm danh mục tin tức
            </Button>
            <Table columns={columns} dataSource={data} rowKey="id" />

            <Modal
                title={editingItem ? 'Chỉnh sửa' : 'Thêm mới'}
                open={isModalOpen}
                onOk={handleOk}
                okText={editingItem ? 'Lưu chỉnh sửa' : 'Thêm mới ngay'}
                cancelText="Hủy"
                width={1000}
                onCancel={handleCancel}>
                <Form form={form} layout="vertical">
                    <Form.Item name="categoryName" label="Tên" rules={[{ required: true, message: 'Hãy nhập tên!' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="status"
                        label="Trạng thái"
                        rules={[{ required: true, message: 'Hãy chọn trạng thái!' }]}
                    >
                        <Select placeholder="Chọn trạng thái">
                            <Option value="Active">Đã xác nhận</Option>
                            <Option value="Deactivate">Chưa xác nhận</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ManageNewsCateForm;
